import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["align", "alignSortIconRight", "Arrows", "children", "Content", "disabled", "FlexContainer", "onClick", "onSortChange", "preferredSort", "sort", "TH", "truncate", "TruncateString"],
  _excluded2 = ["hovered"];
import { forwardRef } from 'react';
import { HoverProvider } from '../HoverProvider';
import { filterProps } from '../../../utils/filterProps';
import { syntheticEvent } from '../../utils/SyntheticEvent';
import { Controllable } from '../Controllable';
import { TFlex } from '../TFlex';
import { TableSortArrows } from './internal/TableSortArrows';
import { SortTH_TH } from './internal/SortTH_TH';
import { SortTH_Content } from './internal/SortTH_Content';
import { SortTH_TruncateString } from './internal/SortTH_TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
export const SortTHComponent = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      align = 'left',
      alignSortIconRight = false,
      Arrows = TableSortArrows,
      children,
      Content = SortTH_Content,
      disabled = false,
      FlexContainer = TFlex,
      onClick,
      onSortChange,
      preferredSort = 'descending',
      sort = 'none',
      TH = SortTH_TH,
      truncate = false,
      TruncateString = SortTH_TruncateString
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    domProps,
    tokenProps,
    callbackProps,
    restProps
  } = filterProps(rest);
  const handleClick = evt => {
    if (onClick) onClick(evt);
    if (evt.defaultPrevented) return;
    let newSort = null;
    if (sort === 'ascending') {
      newSort = 'descending';
    } else if (sort === 'descending') {
      newSort = 'ascending';
    } else {
      newSort = preferredSort;
    }
    onSortChange === null || onSortChange === void 0 || onSortChange(syntheticEvent(newSort));
  };
  return /*#__PURE__*/_jsx(HoverProvider, Object.assign({}, props, {
    children: hoverProviderProps => {
      const {
          hovered
        } = hoverProviderProps,
        hoverProviderRestProps = _objectWithoutPropertiesLoose(hoverProviderProps, _excluded2);
      const arrowsNode = disabled ? null : /*#__PURE__*/_jsx(Arrows, {
        sort: sort
      });
      return /*#__PURE__*/_jsx(TH, Object.assign({}, domProps, tokenProps, restProps, callbackProps, hoverProviderRestProps, {
        disabled: disabled,
        hovered: hovered,
        onClick: handleClick,
        sort: sort,
        ref: ref,
        children: /*#__PURE__*/_jsx(FlexContainer, {
          children: /*#__PURE__*/_jsx(Content, {
            align: align,
            alignSortIconRight: alignSortIconRight,
            arrowsNode: arrowsNode,
            children: truncate ? /*#__PURE__*/_jsx(TruncateString, {
              matchContentWidth: true,
              children: children
            }) : children
          })
        })
      }));
    }
  }));
});
const defaultProps = {
  sort: 'none'
};
export const SortTH = Controllable(SortTHComponent, ['sort'], defaultProps);
SortTH.displayName = 'SortTH';